<template>
   <div class="mt-5 px-0 text-sm">
      <span>{{
         node.content.length > 1 ? $t("system.image_credit.photo_from_top") : $t("system.image_credit.photo_credit")
      }}</span>
      <span v-for="({ content }, index) in imageCredits" :key="`image-credit-${index}`">
         <!-- The text is contained within: image_credit.content[] -> paragraph.content[] -->
         {{ content[0].content[0].text + addSeparator(index) }}
      </span>
   </div>
</template>

<script setup lang="ts">
const props = defineProps({ node: { type: Object, required: true } });

// Filters any paragraph node that does not contain any text
const imageCredits = computed(() => props.node.content.filter(({ content }) => content[0].content));

// Adds a comma if index is not the last one in the list
const addSeparator = (index) => (index + 1 < imageCredits.value.length ? ", " : "");
</script>
